import { render } from "./tzzhd.vue?vue&type=template&id=1cebcd65&scoped=true&ts=true"
import script from "./tzzhd.vue?vue&type=script&lang=ts"
export * from "./tzzhd.vue?vue&type=script&lang=ts"

import "./tzzhd.vue?vue&type=style&index=0&id=1cebcd65&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cebcd65"]])

export default __exports__